'use client';
import { Box, Button } from '@mui/material';
import FilterControllerIcon from './FilterControllerIcon';
import { FunctionComponent } from 'react';
import { useResponsive } from '../../../contexts/ResponsiveContext';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { ProductsContent } from '../../../graphql/pimcore/modules/siteContent/types/ProductsContent';

interface MobileFilterControllerProps {
    isFilterControllerOpen: boolean;
    toggleFilterController: () => void;
    partCounts: number;
    contentTree: ProductsContent;
}

const MobileFilterController: FunctionComponent<MobileFilterControllerProps> = ({
    isFilterControllerOpen,
    toggleFilterController,
    partCounts,
    contentTree,
}) => {
    const { isScreenMd, isScreenSm, isScreenXs, responsiveWidth, fullScreenWidth } =
        useResponsive();

    if (!isFilterControllerOpen) {
        // 當關閉時，維持原本按鈕樣式，整體都可點擊

        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    // 如果需要垂直置中整個視窗，可以加上 height: '100vh'
                    backgroundColor: 'white',
                }}
            >
                <Button
                    disableRipple // ripple 也關掉，避免按下時出現波紋
                    onClick={toggleFilterController}
                    sx={{
                        fontFamily: 'Poppins',
                        fontWeight: 600,
                        fontSize: 16,
                        lineHeight: '1.125rem',
                        color: 'white',
                        textTransform: 'none',
                        width: responsiveWidth,
                        borderRadius: '10px',
                        backgroundColor: '#B75332',
                        justifyContent: 'center',
                        '&:hover': {
                            backgroundColor: '#B75332',
                        },
                    }}
                    startIcon={<FilterControllerIcon sx={{ color: 'white' }} />}
                >
                    {contentTree.filters.buttonLabels.filterAndSort.content}
                </Button>
            </Box>
        );
    }

    // 當 isFilterControllerOpen 為 true 時，
    // 主按鈕區域不接受點擊且無 hover 效果，但在右側顯示一個獨立可點擊的 X 圖示
    return (
        <Box
            sx={{
                position: 'relative',
                width: responsiveWidth,
                borderRadius: '10px',
                margin: 'auto',
            }}
        >
            <Button
                sx={{
                    pointerEvents: 'none', // 禁用按鈕的點擊與 hover
                    fontFamily: 'Poppins',
                    fontWeight: 600,
                    fontSize: 16,
                    lineHeight: '1.125rem',
                    color: 'black',
                    textTransform: 'none',
                    width: '100%',
                    borderRadius: '10px',
                    backgroundColor: 'transparent',
                    justifyContent: 'space-between',
                    '&:hover': {
                        backgroundColor: 'transparent',
                    },
                    padding: 0,
                }}
            >
                {contentTree.filters.labels.resultCount.content}
                {partCounts.toLocaleString()}
            </Button>
            <Box
                onClick={toggleFilterController}
                sx={{
                    position: 'absolute',
                    right: 0,
                    top: 0,
                    bottom: 0,
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer', // 顯示手型指標
                }}
            >
                <HighlightOffIcon sx={{ color: '#B75332' }} />
            </Box>
        </Box>
    );
};

export default MobileFilterController;
